import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa6de276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vtl vtl-card" }
const _hoisted_2 = {
  key: 0,
  class: "vtl-card-title"
}
const _hoisted_3 = { class: "vtl-card-body" }
const _hoisted_4 = { class: "vtl-row" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  key: 0,
  class: "vtl-loading-mask"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vtl-loading-content" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Loading...")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "vtl-table vtl-table-hover vtl-table-bordered vtl-table-responsive-sm",
  ref: "localTable",
  width: "100%"
}
const _hoisted_10 = { class: "vtl-thead" }
const _hoisted_11 = { class: "vtl-thead-tr" }
const _hoisted_12 = {
  key: 0,
  class: "vtl-thead-th vtl-checkbox-th"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "vtl-tbody"
}
const _hoisted_15 = {
  key: 0,
  class: "vtl-tbody-td"
}
const _hoisted_16 = ["value"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "vtl-tbody-td"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "vtl-paging vtl-row"
}
const _hoisted_27 = { class: "vtl-paging-info col-sm-12 col-md-4" }
const _hoisted_28 = {
  role: "status",
  "aria-live": "polite"
}
const _hoisted_29 = { class: "vtl-paging-change-div col-sm-12 col-md-4" }
const _hoisted_30 = { class: "vtl-paging-count-label" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "vtl-paging-page-label" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "vtl-paging-pagination-div col-sm-12 col-md-4" }
const _hoisted_35 = { class: "dataTables_paginate" }
const _hoisted_36 = { class: "vtl-paging-pagination-ul vtl-pagination" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "First", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "<", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Prev", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, ">", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Last", -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = {
  key: 1,
  class: "vtl-row"
}
const _hoisted_51 = { class: "vtl-empty-msg col-sm-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", _hoisted_10, [
              _createElementVNode("tr", _hoisted_11, [
                (_ctx.hasCheckbox)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "vtl-thead-checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setting.isCheckAll) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.setting.isCheckAll]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    class: _normalizeClass(["vtl-thead-th", col.headerClasses]),
                    key: index,
                    style: _normalizeStyle(col.headerStyles)
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["vtl-thead-column", {
                      'vtl-sortable': col.sortable,
                      'vtl-both': col.sortable,
                      'vtl-asc': _ctx.setting.order === col.field && _ctx.setting.sort === 'asc',
                      'vtl-desc': _ctx.setting.order === col.field && _ctx.setting.sort === 'desc',
                    }]),
                      onClick: ($event: any) => (col.sortable ? _ctx.doSort(col.field) : false)
                    }, _toDisplayString(col.label), 11, _hoisted_13)
                  ], 6))
                }), 128))
              ])
            ]),
            (_ctx.rows.length > 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_ctx.isStaticMode)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.localRows, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: i,
                          class: "vtl-tbody-tr"
                        }, [
                          (_ctx.hasCheckbox)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "vtl-tbody-checkbox",
                                    ref_for: true,
                                    ref: 
                          el => {
                            _ctx.rowCheckbox[i] = el;
                          }
                        ,
                                    value: row[_ctx.setting.keyColumn],
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checked && _ctx.checked(...args)))
                                  }, null, 8, _hoisted_16)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, j) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: j,
                              class: _normalizeClass(["vtl-tbody-td", col.columnClasses]),
                              style: _normalizeStyle(col.columnStyles)
                            }, [
                              (col.display)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: col.display(row)
                                  }, null, 8, _hoisted_17))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_ctx.setting.isSlotMode && _ctx.slots[col.field])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                          _renderSlot(_ctx.$slots, col.field, { value: row }, undefined, true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row[col.field]), 1))
                                  ], 64))
                            ], 6))
                          }), 128))
                        ]))
                      }), 128))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.rows, (row, i) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: i,
                          class: "vtl-tbody-tr"
                        }, [
                          (_ctx.hasCheckbox)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "vtl-tbody-checkbox",
                                    ref_for: true,
                                    ref: 
                          el => {
                            _ctx.rowCheckbox[i] = el;
                          }
                        ,
                                    value: row[_ctx.setting.keyColumn],
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checked && _ctx.checked(...args)))
                                  }, null, 8, _hoisted_21)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, j) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: j,
                              class: _normalizeClass(["vtl-tbody-td", col.columnClasses]),
                              style: _normalizeStyle(col.columnStyles)
                            }, [
                              (col.display)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: col.display(row)
                                  }, null, 8, _hoisted_22))
                                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (_ctx.setting.isSlotMode && _ctx.slots[col.field])
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                          _renderSlot(_ctx.$slots, col.field, { value: row }, undefined, true)
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(row[col.field]), 1))
                                  ]))
                            ], 6))
                          }), 128))
                        ]))
                      }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ])
      ]),
      (_ctx.rows.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            (!_ctx.setting.isHidePaging)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("labels.pagingInfo", [_ctx.setting.offset, _ctx.setting.limit, _ctx.total])), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("labels.pageSizeChangeLabel")), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "vtl-paging-count-dropdown",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.setting.pageSize) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageOptions, (pageOption) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: pageOption.value,
                          key: pageOption.value
                        }, _toDisplayString(pageOption.text), 9, _hoisted_31))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.setting.pageSize]
                    ]),
                    _createElementVNode("span", _hoisted_32, "  " + _toDisplayString(_ctx.$t("labels.gotoPageLabel")), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "vtl-paging-page-dropdown",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setting.page) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.maxPage, (n) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: n,
                          value: parseInt(n)
                        }, _toDisplayString(n), 9, _hoisted_33))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.setting.page]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("ul", _hoisted_36, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-first page-item", { disabled: _ctx.setting.page <= 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-first page-link",
                            href: "javascript:void(0)",
                            "aria-label": "Previous",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setting.page = 1))
                          }, _hoisted_39)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-prev page-item", { disabled: _ctx.setting.page <= 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-prev page-link",
                            href: "javascript:void(0)",
                            "aria-label": "Previous",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                          }, _hoisted_42)
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.paging, (n) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-number page-item", { disabled: _ctx.setting.page === n }]),
                            key: n
                          }, [
                            _createElementVNode("a", {
                              class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-number page-link",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.movePage(n))
                            }, _toDisplayString(n), 9, _hoisted_43)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-next page-item", { disabled: _ctx.setting.page >= _ctx.setting.maxPage }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-next page-link",
                            href: "javascript:void(0)",
                            "aria-label": "Next",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                          }, _hoisted_46)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-last page-item", { disabled: _ctx.setting.page >= _ctx.setting.maxPage }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-last page-link",
                            href: "javascript:void(0)",
                            "aria-label": "Next",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setting.page = _ctx.setting.maxPage))
                          }, _hoisted_49)
                        ], 2)
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("labels.noDataAvailable")), 1)
          ]))
    ])
  ]))
}